<template>
  <div class="about-us">
    <header class="page-header">
      <van-icon name="arrow-left" @click="$router.go(-1)" />
      <span>{{ title }}</span>
      <span></span>
    </header>
    <main class="page-body">
      <van-cell-group>
        <van-field
          v-model="original"
          :label="$t('Translate.原文')"
          type="textarea"
          :placeholder="$t('Translate.请输入要翻译的内容')"
          autosize
          :border="true"
        />
        <van-field
          v-model="output"
          :label="$t('Translate.译文')"
          type="textarea"
          :placeholder="$t('Translate.翻译结果')"
          autosize
          block
          :border="true"
        />

        <van-row>
          <van-col span="12">
            <van-button type="info" block @click="onTranslate">{{
              $t('Translate.翻译')
            }}</van-button></van-col
          >
          <van-col span="12"
            ><van-button
              style="background-color:#1989fa;"
              type="primary"
              id="copy"
              :data-clipboard-text="output"
              block
              @click="copy"
              >{{ $t('一键复制') }}</van-button
            ></van-col
          >
        </van-row>
      </van-cell-group>
    </main>
  </div>
</template>
<script>
import { translateAction } from '@/api/website.js';
import { $t } from '@/plugins/i18n';
import Clipboard from 'clipboard';
import store from '@/store';

export default {
  data() {
    return {
      title: $t('便捷翻译'),
      original: '',
      output: '',
      loading: false,
    };
  },
  mounted() {},
  methods: {
    onTranslate() {
      let lang = store.getters.language ?? 'zh';
      this.loading = true;
      translateAction(this.original, lang).then(res => {
        if (res.Result == true) {
          this.output = res.DataDict['data'];
        } else {
          this.$toast.fail($t('翻译失败！'));
        }
        this.loading = false;
      });
    },

    copy() {
      let _this = this;
      let clipborad = new Clipboard('#copy');
      //复制成功
      clipborad.on('success', function() {
        _this.$toast.success($t('复制成功！'));
        clipborad.destory();
      });
      //复制失败
      clipborad.on('error', function() {
        _this.$toast.fail($t('复制失败！'));
        clipborad.destory();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/_var';

.banner {
  height: rem(240px);
  margin-bottom: rem(40px);
  background-color: $theme-color;
  background-size: cover;
}
.page-body {
  padding: rem(40px);
  background: #fff;
}
h1 {
  font-size: 16px;
}
h2 {
  font-size: 12px;
  color: #b8b8b8;
}
p {
  line-height: 1.5;
}
</style>
